const TantanganMengemudi: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-xl font-semibold mb-3">🤖 Robot Penghindar Rintangan: Cerdas, Lincah, dan Penuh Aksi!</h2>

            <p className="mb-4">
                Dalam lomba ini, para peserta ditantang untuk merancang robot yang bisa <span className="font-semibold">bergerak sendiri dan menghindari rintangan secara otomatis</span>. Kedengarannya mudah, tapi sebenarnya butuh perpaduan antara teknik, logika, dan strategi!
            </p>

            <p className="mb-4">
                Setiap tim menggunakan berbagai <span className="font-medium">sensor seperti ultrasonik, IR (infrared), atau bahkan kamera</span> untuk membantu robot mengenali rintangan di depannya. Sensor-sensor ini akan mengirimkan data ke otak robot (biasanya mikrokontroler seperti Arduino), lalu diproses menggunakan logika pemrograman yang sudah mereka rancang.
            </p>

            <h3 className="text-lg font-semibold mb-2">🧠 Strategi Unik dari Tiap Tim:</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Ada yang memilih robot super cepat, meski risikonya tabrak tembok 😅</li>
                <li>Ada juga yang main aman dengan robot lambat tapi sangat stabil.</li>
                <li>Beberapa tim menambahkan suara atau lampu sebagai penanda saat robot mendeteksi rintangan!</li>
            </ul>

            <p>
                Lomba ini bukan hanya tentang siapa yang paling cepat sampai tujuan, tapi juga <span className="font-semibold">siapa yang bisa berpikir kreatif dan menyelesaikan masalah dengan cerdas</span>. Dan tentu saja, penonton pun dibuat tegang—kadang tertawa, kadang bersorak—melihat aksi para robot yang kadang tak terduga!
            </p>
        </div>
    )
}
export default TantanganMengemudi